import { apiGet } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { DesignationsResponse } from '@/constants/types';

class DesignationsService {
  async getDesignations(): Promise<DesignationsResponse> {
    try {
      const response = await apiGet<DesignationsResponse>(
        API_ENDPOINTS.DESIGNATIONS.GET_ALL,
        { showLoader: false }
      );
      return response;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Failed to fetch designations');
    }
  }
}

export const designationsService = new DesignationsService();